<template>
    <!-- Panel -->
    <div v-if="pictogram" class="w-full mt-8">
      <div v-if="pictogram" class="flex flex-row w-full text-blue font-bold mt-3">{{ pictogram.name }}</div>
      <div v-if="pictogram" class="flex flex-row w-full text-blue font-bold">% de Avance {{ pictogram.activity_name }}</div>
      <div class="flex flex-row w-full"><line-chart :suffix="'%'" :data="dataset" /></div>
    </div>
</template>

<script>
  import { fetchPictogramProgressDataset } from '../../services/progress.service'

  export default {
    name: "ViewerChartsetPart",

    props: {
      pictogramId: { type: Number, required: true }
    },

    watch: {
    },

    data() {
      return {
        pictogram: null,
        dataset: null,
      }
    },

    mounted() {
      this.getPanel()
    },

    methods: {
      async getPanel() {
        try {
          const result = await fetchPictogramProgressDataset(this.pictogramId)
          if (result.success) {
            this.pictogram = result.pictogram
            this.dataset = result.dataset
          } else {
            this.$notify.warning(result.msg)
          }
        } catch (error) {
          console.log("Error loading panel")
          this.$notify.error(error.error_msg || 'error_retrieving_data')
        }
      },
    }
  }

</script>

<style scoped>

</style>
